@if (diagnostics(); as diagnostics) {
    <div class="flex gap-4 p-14 pt-2 sm:p-0 md:px-6 md:pb-8 lg:flex-col">
        <div class="w-5/12 lg:w-full">
            <app-diagnostic-information-form [diagnostics]="diagnostics"></app-diagnostic-information-form>
        </div>
        <div class="w-7/12 lg:w-full">
            @if (diagnostics.length === 1) {
                <app-diagnostic-score [diagnostic]="diagnostics[0]" [isPreview]="true"></app-diagnostic-score>
            } @else {
                <app-aggregated-diagnostics-score [diagnostics]="diagnostics" [isPreview]="true"></app-aggregated-diagnostics-score>
            }
        </div>
    </div>
}
